module.exports = __webpack_public_path__ + "img/sw09.4e322ea6.jpg";